import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface inventorySearchParams {
  id?: string;
  inventoryId?: string;
  officeId?: string;
  totalItems?: number;
  itemName?: string;
  numbersOfItems?: number;
  locationDetail?: string;
  conditionStatus?: string;
  itemDescription?: string;
  area?: string;
  building?: string;
  floor?: string;
  brand?: string;
  serialNumber?: string;
  assessmentDate?: (Date | null);
  installationDate?: (Date | null);
  warrantyExpiry?: (Date | null);
  limit?: number;
  offset?: number;
  keyword?: string;
  orderBy?: string;
  order?: string;
}

interface InventoryCreateResponse {
  id: string;
  officeId: string;
  totalItems: number | null;
  itemName: string;
  conditionStatus: string;
  quantity: number | null;
}

export interface InventoryDetailCreatePayload {
  inventoryId: string;
  itemDetailId: string;
  numberOfItems: number;
  locationInfo: string;        // Wajib string
  assetCondition: string;      // Wajib string
  detailDescription: string;   // Wajib string
  area: string;
  building: string;
  floor: string;
  brand: string;
  serialNumber: string;
  assessmentDate: Date | null;
  installationDate: Date | null;
  warrantyExpiry: Date | null;
}

export const getInventories = async (params: inventorySearchParams = {}) => {
  try {
    const response = await axiosInstance.get(
      "/building/inventory/search_building_inventories", { params }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
      "Gagal mengambil data inventory. Silakan coba lagi."
    );
  }
};

// Step 1: Create Inventory
export const createInventory = async (data: {
  officeId: string;
  totalItems: number;
  quantity: number | null;
  itemName: string;
  conditionStatus: string;
}): Promise<InventoryCreateResponse> => {
  try {
    const response = await axiosInstance.post(
      `building/inventory/create_building_inventory`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data);
    throw error;
  }
};

export const deleteInventory = async (id: string) => {
  try {
    await axiosInstance.delete(
      `/building/inventory/delete_building_inventory/${id}`
    );
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus inventory"
    );
  }
};

// Update Vendor
export const updateInventory = async (data) => {
  const payloadEdit = {
    id: data.id,
    officeId: data.officeId,
    totalItems: data.totalItems,
    itemName: " ",
    quantity: 0,
    conditionStatus: " ",
  };

  const response = await axiosInstance.put(
    `/building/inventory/update_building_inventory/${data.id}`,
    payloadEdit
  );
  return response.data;
};

// Fungsi untuk mencari vendor berdasarkan keyword
export const sesarchInventories = async (searchQuery: string) => {
  try {
    const response = await axiosInstance.get(
      `/building/inventory/search_building_inventory?keyword=${searchQuery}`
    );
    return response.data; // Pastikan response sesuai format yang diterima tabel
  } catch (error) {
    console.error("Error fetching inventory:", error);
    throw (
      error.response?.data?.message ||
      "Terjadi kesalahan saat mengambil data inventory"
    );
  }
};

export const getInventoryDetails = async (params: inventorySearchParams = {}) => {
  try {
    const response = await axiosInstance.get(
      "/building/inventory-detail/search_building_inventory_details", { params }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
      "Gagal mengambil data inventory details. Silakan coba lagi."
    );
  }
};

// Step 1: Create Vendor
export const createInventoryDetail = async (data: InventoryDetailCreatePayload) => {
  try {
    const response = await axiosInstance.post(
      `building/inventory-detail/create_building_inventory_detail`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data);
    throw error;
  }
};

export const deleteInventoryDetail = async (id: string) => {
  try {
    await axiosInstance.delete(
      `/building/inventory-detail/delete_building_inventory_detail/${id}`
    );
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor"
    );
  }
};

// Update Vendor
export const updateInventoryDetail = async (data) => {
  const payloadEdit = {
    id: data.id,
    inventoryId: data.inventoryId,
    itemDetailId: data.itemDetailId,
    numberOfItems: data.numberOfItems,
    locationInfo: data.locationInfo,
    assetCondition: data.assetCondition,
    detailDescription: data.detailDescription,
    area: data.area,
    building: data.building,
    floor: data.floor,
    brand: data.brand,
    serialNumber: data.serialNumber,
    assessmentDate: data.assessmentDate,
    installationDate: data.installationDate,
    warrantyExpiry: data.warrantyExpiry
  };

  const response = await axiosInstance.put(
    `/building/inventory-detail/update_building_inventory_detail/${data.id}`,
    payloadEdit
  );
  return response.data;
};

// Fungsi untuk mencari vendor berdasarkan keyword
export const sesarchInventoryDetails = async (searchQuery: string) => {
  try {
    const response = await axiosInstance.get(
      `/building/inventory-detail/search_building_inventory_details?keyword=${searchQuery}`
    );
    return response.data; // Pastikan response sesuai format yang diterima tabel
  } catch (error) {
    console.error("Error fetching inventory:", error);
    throw (
      error.response?.data?.message ||
      "Terjadi kesalahan saat mengambil data inventory"
    );
  }
};

export const uploadItemPhoto = async (inventoryDetailId: string, file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    await axiosInstance.post(
      `/building/inventory-detail/upload_item_photo/${inventoryDetailId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Failed to upload photo:", error);
    throw error;
  }
};

export const deleteItemPhoto = async (id: string, type) => {
  try {
    await axiosInstance.delete(`/building/inventory-detail/delete_item_photo/${id}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor"
    );
  }
};

export const fetchItemPhotoBlob = async (
  filename: string
): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(
      `/building/inventory-detail/item_photo/${filename}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response.data);
    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};

export const uploadItemFile = async (inventoryDetailId: string, file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    await axiosInstance.post(
      `/building/inventory-detail/upload_item_file/${inventoryDetailId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Failed to upload file:", error);
    throw error;
  }
};

export const deleteItemFile = async (id: string) => {
  try {
    await axiosInstance.delete(`/building/inventory-detail/delete_item_file/${id}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus file"
    );
  }
};

export const fetchItemFileBlob = async (
  filename: string
): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(
      `/building/inventory-detail/item_photo/${filename}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil file:", error);
    return null;
  }
};